import { render } from "./CommonButtonMore.vue?vue&type=template&id=800e0852&scoped=true&ts=true"
import script from "./CommonButtonMore.vue?vue&type=script&lang=ts"
export * from "./CommonButtonMore.vue?vue&type=script&lang=ts"

import "./CommonButtonMore.vue?vue&type=style&index=0&id=800e0852&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-800e0852"]])

export default __exports__